module.exports = __webpack_public_path__ + "img/eagleWingsLogo@3x.f730ea7b.png";